import React from 'react';

class SettopBoxIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_254_1493)">
          <g filter="url(#filter0_d_254_1493)">
            <path
              d="M74.4 24.9399H5.6C4.71634 24.9399 4 25.6563 4 26.5399V50.1399C4 51.0236 4.71634 51.7399 5.6 51.7399H74.4C75.2837 51.7399 76 51.0236 76 50.1399V26.5399C76 25.6563 75.2837 24.9399 74.4 24.9399Z"
              fill="#F7F4F1"
            />
            <path
              d="M70.4246 28.834H54.8086C53.8189 28.834 53.0166 29.6363 53.0166 30.626V46.242C53.0166 47.2317 53.8189 48.034 54.8086 48.034H70.4246C71.4143 48.034 72.2166 47.2317 72.2166 46.242V30.626C72.2166 29.6363 71.4143 28.834 70.4246 28.834Z"
              fill="url(#paint0_linear_254_1493)"
            />
            <path
              d="M27.28 51.8079H12.372C12.1666 51.8079 12 51.9744 12 52.1799V54.4979C12 54.7033 12.1666 54.8699 12.372 54.8699H27.28C27.4855 54.8699 27.652 54.7033 27.652 54.4979V52.1799C27.652 51.9744 27.4855 51.8079 27.28 51.8079Z"
              fill="#E4E1DE"
            />
            <path
              d="M67.628 51.74H52.372C52.1665 51.74 52 51.9065 52 52.112V54.498C52 54.7034 52.1665 54.87 52.372 54.87H67.628C67.8335 54.87 68 54.7034 68 54.498V52.112C68 51.9065 67.8335 51.74 67.628 51.74Z"
              fill="#E4E1DE"
            />
            <path
              d="M74.4002 24.1399H5.6002C4.2762 24.1399 3.2002 25.2159 3.2002 26.5399V50.1399C3.2002 51.4639 4.2762 52.5399 5.6002 52.5399H11.2002V54.4999C11.2002 55.1459 11.7262 55.6719 12.3722 55.6719H27.2822C27.9282 55.6719 28.4542 55.1459 28.4542 54.4999V52.5399H51.2002V54.4999C51.2002 55.1459 51.7262 55.6719 52.3722 55.6719H67.6302C68.2762 55.6719 68.8022 55.1459 68.8022 54.4999V52.5399H74.4022C75.7262 52.5399 76.8022 51.4639 76.8022 50.1399V26.5399C76.8022 25.2159 75.7262 24.1399 74.4022 24.1399H74.4002ZM26.8522 54.0699H12.8002V52.6079H26.8522V54.0699ZM67.1982 54.0699H52.7982V52.5399H67.1982V54.0699ZM75.1982 50.1399C75.1982 50.5819 74.8402 50.9399 74.3982 50.9399H5.6002C5.1582 50.9399 4.8002 50.5819 4.8002 50.1399V26.5399C4.8002 26.0979 5.1582 25.7399 5.6002 25.7399H74.4002C74.8422 25.7399 75.2002 26.0979 75.2002 26.5399V50.1399H75.1982Z"
              fill="#84827E"
            />
            <path
              d="M10.9998 47.34C12.2148 47.34 13.1998 46.355 13.1998 45.14C13.1998 43.9249 12.2148 42.9399 10.9998 42.9399C9.78478 42.9399 8.7998 43.9249 8.7998 45.14C8.7998 46.355 9.78478 47.34 10.9998 47.34Z"
              fill="#84827E"
            />
            <path
              d="M17.9998 47.34C19.2148 47.34 20.1998 46.355 20.1998 45.14C20.1998 43.9249 19.2148 42.9399 17.9998 42.9399C16.7848 42.9399 15.7998 43.9249 15.7998 45.14C15.7998 46.355 16.7848 47.34 17.9998 47.34Z"
              fill="#84827E"
            />
            <path
              d="M25.2 47.34C26.415 47.34 27.4 46.355 27.4 45.14C27.4 43.9249 26.415 42.9399 25.2 42.9399C23.985 42.9399 23 43.9249 23 45.14C23 46.355 23.985 47.34 25.2 47.34Z"
              fill="#84827E"
            />
            <path
              d="M62.6164 39.3779C62.1744 39.3779 61.8164 39.0199 61.8164 38.5779V32.8339C61.8164 32.3919 62.1744 32.0339 62.6164 32.0339C63.0584 32.0339 63.4164 32.3919 63.4164 32.8339V38.5779C63.4164 39.0199 63.0584 39.3779 62.6164 39.3779Z"
              fill="white"
            />
            <path
              d="M62.6163 44.834C59.2143 44.834 56.4463 42.066 56.4463 38.664C56.4463 36.448 57.6463 34.39 59.5803 33.294C59.9643 33.076 60.4523 33.212 60.6703 33.596C60.8883 33.98 60.7523 34.468 60.3683 34.686C58.9363 35.498 58.0463 37.022 58.0463 38.662C58.0463 41.182 60.0963 43.232 62.6163 43.232C65.1363 43.232 67.1863 41.182 67.1863 38.662C67.1863 37.02 66.2963 35.496 64.8643 34.686C64.4803 34.468 64.3443 33.98 64.5623 33.596C64.7803 33.212 65.2683 33.076 65.6523 33.294C67.5843 34.39 68.7863 36.446 68.7863 38.664C68.7863 42.066 66.0183 44.834 62.6163 44.834Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_254_1493"
            x="1.8002"
            y="22.7399"
            width="79.6016"
            height="37.532"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_254_1493"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_254_1493"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_254_1493"
            x1="55.7171"
            y1="30.5513"
            x2="68.7502"
            y2="45.501"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_254_1493">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default SettopBoxIcon;
